import Axios from "axios";
import request from "./request"

const queryMiniappWechatPay = async (params) => {
    const resp = await request.post(`api/v1/payment/miniapp/wechatpay/status`, params);
    return resp.data;
  };
  
export default queryMiniappWechatPay;